import { useCallback, useEffect, useState } from 'react';

import type { NavTreeItem, ActiveDocMeta } from '@models/NavigationTree';

const checkIfIsSubSlug = (currentItemSlug: string, activeItemSlug: string): boolean => {
  if (!activeItemSlug.indexOf(currentItemSlug)) {
    const restSlug = activeItemSlug.replace(currentItemSlug, '');
    if (!restSlug || restSlug[0] === '/') {
      return true;
    }
  }
  return false;
};

const checkIfIsChildDocument = (item: NavTreeItem, activeItemSlug: string): boolean => {
  if (item.children === undefined) {
    return false;
  }

  return item.children.some((childItem: NavTreeItem) => {
    if (childItem?.meta?.slug === activeItemSlug) {
      return true;
    }
    if (childItem.children !== undefined) {
      return checkIfIsChildDocument(childItem, activeItemSlug);
    }
    return false;
  });
};

const checkIfIsParentTree = (item: NavTreeItem, activeItemSlug: string): boolean => {
  const currentItemSlug = item.meta.slug || '';

  return checkIfIsSubSlug(currentItemSlug, activeItemSlug) || checkIfIsChildDocument(item, activeItemSlug);
};

// consider to refactor this and move it inside "NavTreeElement"
export const useNavigationItem = (item: NavTreeItem, activeDocMeta: ActiveDocMeta) => {
  const activeItemSlug = activeDocMeta.slug || '';
  const currentItemSlug = item.meta.slug || '';
  const isParentTree = checkIfIsParentTree(item, activeItemSlug);
  const isActive = currentItemSlug === activeItemSlug;

  const [isOpened, setIsOpened] = useState<boolean>(isParentTree);

  useEffect(() => {
    setIsOpened(isParentTree);
  }, [isParentTree]);

  const onDirectoryItemClickHandler = useCallback(() => {
    setIsOpened((prev) => !prev);
  }, []);

  return {
    isActive,
    isOpened,
    isParentTree,
    onDirectoryItemClickHandler,
  };
};
